import UserCentricViewController from '../../usercentrics-view-controller';

const _ = require('lodash');
const stateName = 'secondaryAdvancePrivacyView';

const showSecondaryBasicViewСlassName = 'show-secondary-basic-view';
const closeBtnClassName = 'close-modal-btn';
const overlayClassName = 'inactive-background';
const cancelBtnClassName = 'cancel-modal-btn';
const saveInfoBtnClassName = 'uc-save-settings-button';

const openSettingsTabId = 'uc-btn-select-tab-settings';
const openHistoryTabId = 'uc-btn-select-tab-history';
const openPurposeTabId = 'uc-btn-select-tab-purpose';

const openConsentInfoModalEventName = 'open-consent-info-modal';
const toggleBannerVisibleStatusClassName = 'uc-show-hide-banner';

const cornerModalSecondaryAdvancePrivacyTemplate1
    = require('./templates/privacy-corner-modal-templates/secondary-advance-privacy-corner-modal-template-1.hbs');
const cornerModalSecondaryAdvancePrivacyTemplate5
    = require('./templates/privacy-corner-modal-templates/secondary-advance-privacy-corner-modal-template-5.hbs');
const cornerModalSecondaryAdvancePrivacyTemplate8
    = require('./templates/privacy-corner-modal-templates/secondary-advance-privacy-corner-modal-template-8.hbs');
const cornerModalSecondaryAdvancePrivacyTemplate11
    = require('./templates/privacy-corner-modal-templates/secondary-advance-privacy-corner-modal-template-11.hbs');
const cornerModalSecondaryAdvancePrivacyTemplate12
    = require('./templates/privacy-corner-modal-templates/secondary-advance-privacy-corner-modal-template-12.hbs');

const centerModalSecondaryAdvancePrivacyTemplate1
    = require('./templates/privacy-center-modal-templates/secondary-advance-privacy-center-modal-template-1.hbs');
const centerModalSecondaryAdvancePrivacyTemplate11
    = require('./templates/privacy-center-modal-templates/secondary-advance-privacy-center-modal-template-11.hbs');

import SecondaryAdvanceSettingsViewController from './settings/settings-view-controller';
import SecondaryAdvanceHistoryViewController from './history/history-view-controller';
import SecondaryAdvancePurposeViewController from './purpose/purpose-view-controller';

import BannerViewController from '../../banner/banner-modal-view-controller';
import { SettingsService } from '../../../../services/settings-service';
import { CustomEmbedService } from '../../../../services/utilities/custom-embed.service';
import { debounce } from 'ts-debounce';
import { ConsentsStatusService } from '../../../../services/consents-services/consents-status.service';
import { DataService } from '../../../../services/utilities/data.service';
import { GetConsentsService } from '../../../../services/consents-services/get-consents.service';
import { Consent } from '../../../../dataTypes/type-consent';

export enum FieldSelectionStatus {
    NoneSelected = 0,
    AllSelected = 1,
    SomeSelected = 2
}

export default class SecondaryAdvancePrivacyViewController {
    private secondaryAdvanceSettingsViewController: SecondaryAdvanceSettingsViewController;
    private secondaryAdvanceHistoryViewController: SecondaryAdvanceHistoryViewController;
    private secondaryAdvancePurposeViewController: SecondaryAdvancePurposeViewController;
    private BannerViewController: BannerViewController;
    private languageService: any;
    private mainViewContoller: any;
    private modalScope: any;
    private layoutParams: any;
    private settingsService: SettingsService;
    private utilityService: any;
    private isVisible: boolean;

    private showSecondaryBasicViewBtns: any;
    private saveInfoBtns: any;
    private closeBtns: any;
    private cancelBtns: any;

    private showHideBannerElms: any;
    private useIabTemplate: boolean = false;
    public isLoading = false; // to prevent multiclick

    constructor(
        mainViewContoller,
        modalScope,
        layoutParams,
        bannerController,
        utilityService
    ) {
        this.utilityService = utilityService;
        this.BannerViewController = bannerController;
        this.settingsService = utilityService.settingsService;
        this.isVisible = false;
        this.layoutParams = layoutParams;
        this.languageService = utilityService.languageService;
        this.mainViewContoller = mainViewContoller;
        this.modalScope = modalScope;

        this.secondaryAdvanceSettingsViewController = new SecondaryAdvanceSettingsViewController(
            modalScope,
            layoutParams,
            utilityService,
            this
        );

        this.secondaryAdvanceHistoryViewController = new SecondaryAdvanceHistoryViewController(
            this,
            modalScope,
            layoutParams,
            utilityService
        );

        this.secondaryAdvancePurposeViewController = new SecondaryAdvancePurposeViewController(
            modalScope,
            utilityService,
            this
        );

        this.setMainViewControllerVisibility();
    }

    public updatePurposeStatus(purposeStatus: IAB.PurposeStatus): void {
        this.secondaryAdvancePurposeViewController.updatePurposeStatus(purposeStatus);
    }

    private setMainViewControllerVisibility(): void {
        this.useIabTemplate = this.utilityService.useIabTemplate();
        this.secondaryAdvanceSettingsViewController.visible = !this.useIabTemplate;
        this.secondaryAdvancePurposeViewController.visible = this.useIabTemplate;
    }

    private setState(): void {
        this.modalScope.changeState(stateName);
    }

    updateView(): void {
        const modalWrapperElement = this.modalScope.getModalWrapperElement();
        modalWrapperElement.innerHTML = this.htmlString;
        this.initHandling();
        CustomEmbedService.injectCurrentDate();
    }

    private getViewHTML() {
        switch (this.layoutParams.modalView) {
            case 'center-modal-template-11':
                return centerModalSecondaryAdvancePrivacyTemplate11;
            case 'corner-modal-template-1':
                return cornerModalSecondaryAdvancePrivacyTemplate1;
            case 'corner-modal-template-5':
                return cornerModalSecondaryAdvancePrivacyTemplate5;
            case 'corner-modal-template-8':
                return cornerModalSecondaryAdvancePrivacyTemplate8;
            case 'corner-modal-template-11':
                return cornerModalSecondaryAdvancePrivacyTemplate11;
            case 'corner-modal-template-12':
                return cornerModalSecondaryAdvancePrivacyTemplate12;
            case 'center-modal-template-1':
            case 'center-modal-template-8':
            default:
                return centerModalSecondaryAdvancePrivacyTemplate1;
        }
    }

    private getHtml() {
        const viewHTML: any = this.getViewHTML();
        this.utilityService.developmentLog('getting advance privacy modal HTML');

        let bgData = {
            darken: 0,
            overlayBackground: false,
            clickToClose: false,
        };

        if (this.utilityService.bgOverlayService) {
            const modalView = this.layoutParams.modalView.substring(0, 12) === 'center-modal' ? 'centralModal' : 'cornerModal';
            bgData = this.utilityService.bgOverlayService.getOverlayProperty(modalView);
        }

        this.utilityService.developmentLog(
            'getting view data in advance privacy modal HTML'
        );

        const viewData = {
            consentsHistory: this.secondaryAdvanceHistoryViewController.htmlString,
            consentsSettings: this.secondaryAdvanceSettingsViewController.htmlString,
            consentsPurpose: this.secondaryAdvancePurposeViewController.htmlString,
            bgData: bgData,
            settings: this.settingsService.settings,
            languageControl: this.modalScope.getModalWrapperElement()
                ? this.languageService.htmlString(
                    this.modalScope.getModalWrapperElement().id
                )
                : this.languageService.htmlString(),
            historyTabActive: this.secondaryAdvanceHistoryViewController.visible,
            settingsTabActive: this.secondaryAdvanceSettingsViewController.visible,
            purposeTabActive: this.secondaryAdvancePurposeViewController.visible,
            useIabTemplate: this.useIabTemplate,
            secondaryAdvanceVisible: this.visible,
            secondaryBasicVisible: this.modalScope.secondaryBasicPrivacyViewController ? this.modalScope.secondaryBasicPrivacyViewController
                .visible : false,
            elementsVisibility: this.settingsService.elementsVisibility,
            location: this.settingsService.settings.buttonDisplayLocation,
            icons: UserCentricViewController.icons,
        };

        this.utilityService.developmentLog('got advance privacy modal HTML');
        return viewHTML(viewData);
    }

    public getExternalFieldSelectionStatus(list: any[], statusField: IAB.PurposeStatus, fieldName: string): FieldSelectionStatus {
        const selectionLenght: number = list.filter(item => statusField[item[fieldName]] === true).length;
        if (selectionLenght === list.length) {
            return FieldSelectionStatus.AllSelected;
        } else if (selectionLenght === 0) {
            return FieldSelectionStatus.NoneSelected;
        }

        return FieldSelectionStatus.SomeSelected;
    }

    public getFieldSelectionStatus(list: any[], fieldName: string): FieldSelectionStatus {
        const selectionLenght: number = list.filter(item => item[fieldName] === true).length;
        if (selectionLenght === list.length) {
            return FieldSelectionStatus.AllSelected;
        } else if (selectionLenght === 0) {
            return FieldSelectionStatus.NoneSelected;
        }

        return FieldSelectionStatus.SomeSelected;
    }

    public initHandling() {
        this.utilityService.developmentLog(
            'initializing advance privacy modal HTML'
        );

        const modalWrapperElement = this.modalScope.getModalWrapperElement();
        if (this.isVisible && modalWrapperElement) {
            const openConsentInfoModalBtns = modalWrapperElement.querySelectorAll(
                '[data-event=' + openConsentInfoModalEventName + ']'
            );
            _.forEach(openConsentInfoModalBtns, openConsentInfoModalBtn => {
                if (openConsentInfoModalBtn) {
                    const dataId = openConsentInfoModalBtn.getAttribute('data-id');
                    openConsentInfoModalBtn.onclick = (event: any) => {
                        if (this.secondaryAdvancePurposeViewController.visible) {
                            const consent: Consent.Consent = GetConsentsService.getConsentByIabId(dataId);
                            if (consent) {
                                this.openConsentInfoModal(consent.templateId);
                            } else {
                                this.openConsentInfoModal(dataId);
                            }
                        } else if (dataId) {
                            this.openConsentInfoModal(dataId);
                        } else {
                            this.openConsentInfoModal();
                        }
                    };
                }
            });

            this.showSecondaryBasicViewBtns = modalWrapperElement.getElementsByClassName(
                showSecondaryBasicViewСlassName
            );
            _.forEach(this.showSecondaryBasicViewBtns, showSecondaryBasicViewBtn => {
                if (showSecondaryBasicViewBtn) {
                    showSecondaryBasicViewBtn.onclick = (event: any) => {
                        const switchElements = showSecondaryBasicViewBtn.getElementsByClassName(
                            'switch1'
                        );
                        if (switchElements[0].classList.contains('on')) {
                            switchElements[0].classList.add('off');
                            switchElements[0].classList.remove('on');
                        } else {
                            switchElements[0].classList.add('on');
                            switchElements[0].classList.remove('off');
                        }
                        this.showBasicView(switchElements[0].classList.contains('off'));
                    };
                }
            });

            this.cancelBtns = modalWrapperElement.getElementsByClassName(
                cancelBtnClassName
            );
            _.forEach(this.cancelBtns, cancelBtn => {
                if (cancelBtn) {
                    cancelBtn.onclick = (event: any) => {
                        this.cancel();
                    };
                }
            });

            this.closeBtns = modalWrapperElement.getElementsByClassName(
                closeBtnClassName
            );
            _.forEach(this.closeBtns, closeBtn => {
                if (closeBtn) {
                    closeBtn.onclick = (event: any) => {
                        this.cancel();
                    };
                }
            });
            const overlays = modalWrapperElement.getElementsByClassName(
                overlayClassName
            );
            _.forEach(overlays, closeBtn => {
                if (closeBtn) {
                    let bgData = {
                        darken: 0,
                        overlayBackground: false,
                        clickToClose: false,
                    };
                    if (this.utilityService.bgOverlayService) {
                        const modalView = this.layoutParams.modalView.substring(0, 12) === 'center-modal' ? 'centralModal' : 'cornerModal';
                        bgData = this.utilityService.bgOverlayService.getOverlayProperty(modalView);
                    }
                    if (bgData.clickToClose) {
                        closeBtn.onclick = (event: any) => {
                            // make sure the click was on the background
                            if (event.target === closeBtn) {
                                this.cancel();
                            }
                        };
                    }
                }
            });

            this.saveInfoBtns = modalWrapperElement.getElementsByClassName(
                saveInfoBtnClassName
            );
            _.forEach(this.saveInfoBtns, saveInfoBtn => {
                if (saveInfoBtn) {
                    saveInfoBtn.onclick = () => {
                        this.save();
                    };
                }
            });

            this.showHideBannerElms = modalWrapperElement.getElementsByClassName(
                toggleBannerVisibleStatusClassName
            );

            _.forEach(this.showHideBannerElms, showHideBannerElm => {
                if (showHideBannerElm) {
                    showHideBannerElm.onclick = (event: any) => {
                        event.preventDefault();
                        event.stopPropagation();
                        this.showHideBanner();
                    };
                }
            });

            const tabs = [
                {
                    id: openSettingsTabId,
                    controllerName: SecondaryAdvanceSettingsViewController.CONTROLLER_NAME
                },
                {
                    id: openHistoryTabId,
                    controllerName: SecondaryAdvanceHistoryViewController.CONTROLLER_NAME
                },
                {
                    id: openPurposeTabId,
                    controllerName: SecondaryAdvancePurposeViewController.CONTROLLER_NAME
                },
            ]
            tabs.forEach(tab => this.registerOnClickEvent(tab, modalWrapperElement));

            this.secondaryAdvanceHistoryViewController.initHandling();
            this.secondaryAdvanceSettingsViewController.initHandling();
            this.secondaryAdvancePurposeViewController.initHandling();
            this.languageService.initHandling();
        }
    }

    public registerOnClickEvent(tab, modalWrapperElement): void {
        const element = modalWrapperElement.querySelector(`#${tab.id}`);

        if (element) {
            element.onclick = (event: any) => {
                event.preventDefault();
                event.stopPropagation();
                this.hideAllTabs();
                this.changeActiveTab(tab.controllerName);
                this.updateView();
            };
        }
    }

    public hideAllTabs() {
        this.secondaryAdvanceSettingsViewController.visible = false;
        this.secondaryAdvanceHistoryViewController.visible = false;
        this.secondaryAdvancePurposeViewController.visible = false;
    }

    public changeActiveTab(viewControllerName) {
        this[viewControllerName].visible = true;
    }

    public openConsentInfoModal(id?) {
        this.utilityService.moreInfoEventsService.openConsentInfoModal(id);
    }

    public showBasicView = debounce(function (showBasic) {
        if (showBasic) {
            this.modalScope.changeState('secondary-basic');
        }
    }, 500);

    public showHideBanner() {
        this.settingsService.bannerIsVisible = !this.settingsService
            .elementsVisibility.bannerVisible;
        this.modalScope.updateView();
    }

    public save(): void {
        if (!this.secondaryAdvancePurposeViewController.visible) {
            const action = 'onSaveBtnClick';
            const updatedBy = 'explicit';
            this.utilityService.saveConsentsService.saveConsents(action, updatedBy);
        } else {
            const purposeStatus = this.secondaryAdvancePurposeViewController.purposeStatus;
            DataService.storeToLocalStorage(this.utilityService.cmpIABService.NON_IAB_PURPOSE_STORAGE_KEY, purposeStatus[this.utilityService.cmpIABService.DEFAULT_NON_IAB_PURPOSE.id]);
            this.utilityService.cmpIABService.updateControllerPurposeStaus(purposeStatus);
            this.utilityService.saveConsentsService.updateConsentsFromPurposes();
        }

        this.settingsService.saveFirstUserInteraction();
        this.modalScope.closeModal();
        this.modalScope.updateView();
    }

    public cancel() {
        ConsentsStatusService.resetAllConsents(DataService.consents);
        this.modalScope.closeModal();
    }

    public resetPurposes() {
        this.secondaryAdvancePurposeViewController.initializePurposeStatus();
    }

    public set visible(visible) {
        this.isVisible = visible;
    }

    public get visible() {
        return this.isVisible;
    }

    public get htmlString(): string {
        if (this.isVisible) {
            return this.getHtml();
        }
        return '';
    }
}
